import React from 'react';
import PropTypes from 'prop-types';

import { Alert } from 'react-bootstrap';

export default function ErrorsAlert({ errors }) {
  return (
    errors && (
      <Alert bsStyle="warning">
        {errors.map((error, i) => (
          <div key={i}>{error}</div>
        ))}
      </Alert>
    )
  );
}

ErrorsAlert.propTypes = {
  errors: PropTypes.array.isRequired,
};
